import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  hasMore: false,
  skip: 0,
  limit: 0,
  total: 0,
  items: [],
  lastItem: null,
  loadAfter: null,
  loading: true,
  loadingError: null,
  loadingMore: false,
  loadingMoreError: null,
  endpoint: null,
  needRefresh: new Date().valueOf(),
};

export const paginationSlice = createSlice({
  name: "pagination",
  initialState,
  // The `reducers` field lets us define reducers and generate associated actions
  reducers: {
    loadedAction: (state, action) => {
      state.items = state.items.concat(action.payload.items);
      state.endpoint = action.payload.endpoint;
      state.loading = false;
      state.loadingError = null;
      state.loadingMore = false;
      state.lastItem = state.items.lastItem;
      state.skip = state.skip + action.payload.items.length;
      state.hasMore = state.items.length < action.payload.total;
      // state.hasMore = end;
      state.total = action.payload.total;
    },
    deleteByIdAction: (state, action) => {
      state.total = state.total - 1;
      state.items = state.items.filter((cur) => cur.id !== action.payload.id);
    },
    loadMoreAction: (state) => {
      state.loadingMore = true;
      state.loadAfter = state.lastItem;
      // state.skip = 0;
    },
    refreshAction: (state) => {
      state.skip = 0;
      state.total = 0;
      state.needRefresh = new Date().valueOf();
      state.hasMore = false;
      state.loading = true;
      state.lastItem = null;
      state.items = [];
    },
    clearAction: (state) => {
      state.hasMore = false;
      state.skip = 0;
      state.limit = 0;
      state.total = 0;
      state.items = [];
      state.lastItem = null;
      state.loadAfter = null;
      state.loading = true;
      state.loadingError = null;
      state.loadingMore = false;
      state.loadingMoreError = null;
      state.endpoint = null;
      state.needRefresh = new Date().valueOf();
    },
    failedAction: (state) => {
      state.loading = false;
    },
  },
});

export const {
  clearAction,
  loadMoreAction,
  loadedAction,
  refreshAction,
  failedAction,
  deleteByIdAction,
} = paginationSlice.actions;

export default paginationSlice.reducer;
